<template>
  <div
    class="calico-file-item"
    :class="{ dark }"
  >
    <div
      class="calico-file-item-content"
      :class="{completed, error}"
    >
      <i :class="`bi ${icon}`" />
      <label class="body--medium">
        {{ name }}
      </label>
      <i
        v-if="completed"
        class="bi bi-trash-fill"
        @click.prevent="onTrash"
      />
      <i
        v-else
        class="bi bi-x-lg"
        @click.prevent="onCancel"
      />
    </div>
    <div class="progressbar">
      <span
        :class="{completed, error}"
        :style="{ width: progress + '%' }"
      />
    </div>
    <div
      v-if="message"
      class="message "
    >
      <label
        class="body--small"
        :class="{error}"
      >
        {{ message }}
      </label>
    </div>
  </div>
</template>
<script lang="js">

export default {
  name: 'CalicoFileItem',
  props: {
    name: {
      type: String,
      default: 'your-file-here'
    },
    message: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 0
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    icon() {
      if (this.completed) {
        return 'bi-check-circle-fill'
      } else if (this.error) {
        return 'bi-exclamation-circle-fill'
      } else {
        return 'bi-circle'
      }
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onTrash() {
      this.$emit('trash')
    }
  }
}
</script>

<style lang="scss">
.calico-file-item {
  @include stack-space($space-none);
  width: 100%;

  .calico-file-item-content {
    @include inline-space($space-small);
    @include inset-squish-space($space-small);
    align-items: center;
    color: $color-text-secondary;

    .b-icon {
      font-size: $icon-xsmall;
      border-radius: 50px;
    }

    .bi-circle {
      color: $color-neutral-light
    }

    .bi-check-circle-fill {
      background-color: white;
      color: $color-semantics-success;
    }

    .bi-exclamation-circle-fill {
      background-color: white;
      color: $color-semantics-error;
    }

    label {
      flex: 1;
      margin: 0px;
    }
  }

  .progressbar {
    display: flex;

    span {
      background: $color-black;
      height: 2px;
      width: 100%;
    }

    .error {
      width: 100% !important;
      background: $color-semantics-error;
    }

    .completed {
      width: 0% !important;
    }
  }

  .message {
    @include stack-space($space-none);
    width: 100%;
    align-items: flex-start;
    justify-content: center;

    .error {
      color: $color-semantics-error;
      margin: 0px;
    }
  }

  .error,
  .completed {
    color: $color-text-primary;
  }

  &.dark {
    
    background-color: $color-neutral-darkest;

    .bi-x-lg {
      color: $color-white;
    }
    .bi-trash-fill {
      color: $color-neutral;
    }

    .bi-check-circle-fill {
      background-color: transparent;
      color: $color-green;
    }

    .bi-exclamation-circle-fill {
      background-color: transparent;
      color: $color-red;
    }

    .error,
    .completed {
      color: $color-text-primary-alt;
    }

    .progressbar {
      span {
        background: $color-white;
      }

      .error {
        background: $color-red;
      }
    }

    .message {
      .error {
        color: $color-red;
      }
    }
  }
}
</style>
